module.exports = __webpack_public_path__ + "static/img/PFK_OurStory_Photo3_390x440.bfb5cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurStory_Photo3_390x440.jpg
// module id = 256
// module chunks = 1